package fr.manyverse.app.domain.model

data class User(
    val id: String,
    val email: String
)
